import React, { FC } from 'react';
import { ComponentConsumerProps, isEditorActive, RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { UserExperienceModel } from './models/userExperience.model';
import { UserExperienceProps } from './types/userExperience.types';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import useExperienceEditorPlaceholder from '../../hooks/useExperienceEditorPlaceholder';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import MediaElement from './components/mediaElement';
import UserExperienceButtons from './components/userExperienceButtons';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import { lineTestimonialsVisible } from '../../constants/analytics.constants';
import './index.scss';

const ProductSeriesListingUserExperience: FC<ComponentConsumerProps & UserExperienceProps> = (props) => {
  const model = UserExperienceModel(props);
  const apiResponse = isEmptyResponse(props);
  const isPlaceholderShown = useExperienceEditorPlaceholder(props);

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return (
      <ExperienceEditorComponentPlaceholder image={props?.fields?.itemData?.thumbnail} componentName={props?.rendering?.componentName} />
    );
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={props?.rendering?.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  return (
    <AnalyticsVisibleEvent event={lineTestimonialsVisible}>
      <div className={`user-experience ${model?.imagePosition === 'right' ? 'user-experience--right' : ''}`}>
        <MediaElement
          videoUrl={model.videoUrl}
          isVideo={model.isVideo}
          bigthumbnail={model.bigthumbnail}
          thumbnail={model.thumbnail}
          altText={model.altText}
        />
        <div className={'user-experience__column user-experience__content'}>
          <div className={'user-experience__column user-experience__content-wrapper'}>
            {model?.eyebrow && <Text tag="p" field={model?.eyebrow} className={'user-experience__eyebrow'} editable={false} />}
            {model?.title && <Text tag="h3" field={model?.title} className={'user-experience__title'} editable={false} />}
            {model?.description && (
              <RichText tag="div" field={model?.description} className={'user-experience__text rich-text'} editable={false} />
            )}
            <UserExperienceButtons button1={model.button1} button2={model.button2} rendering={props?.rendering} />
          </div>
        </div>
      </div>
    </AnalyticsVisibleEvent>
  );
};

export default withSitecoreContext()(ProductSeriesListingUserExperience);
